import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import ChevronLeft from '../svg/ChevronLeft'

function Prev({ active, onClick, style }) {
  return (
    <div onClick={ active ? onClick : null } className={`arrow-link pag-chevron-left`} style={{ ...style, cursor: active ? `pointer` : `default` }}>
      <ChevronLeft color={ active ? Config.TYPE_LIGHT : Config.TYPE_PLACEHOLDER } />
    </div>
  )
}

Prev.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object
}

export default Prev;
